import * as actions from './performance.actions';
import { Performance, PerformanceFilter, Types } from './performance.models';
import { DatesInterval } from '../../global/interfaces';

export interface State {
  loading: boolean;
  dates?: DatesInterval;
  data?: Performance;
  filter: PerformanceFilter;
}

export const initialState: State = {
  loading: false,
  dates: {
    loading: false,
    min: undefined,
    max: undefined
  },
  data: undefined,
  filter: {
    type: 'gross',
    option: 'total',
    fund: '',
    year: undefined,
    month: undefined
  }
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_PERFORMANCE_DATES:
      return { ...state,
        loading: true,
        dates: { min: undefined, max: undefined, loading: true }, filter: { ...state.filter, month: undefined, year: undefined } };
    case actions.ActionTypes.LOAD_PERFORMANCE_DATES_SUCCESS:
      return { ...state, loading: false, dates: { ...action.payload, loading: false } };
    case actions.ActionTypes.LOAD_PERFORMANCE_DATES_FAILED:
      return { ...state, loading: false, dates: { min: undefined, max: undefined, loading: false } };

    case actions.ActionTypes.LOAD_PERFORMANCE_DATA:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_PERFORMANCE_DATA_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case actions.ActionTypes.LOAD_PERFORMANCE_DATA_FAILED:
      return { ...state, loading: false, data: undefined };

    case actions.ActionTypes.SET_PERFORMANCE_TYPE_FILTER:
      return { ...state, filter: { ...state.filter, type: state.filter.type === Types.GROSS ? 'net' : 'gross' } };
    case actions.ActionTypes.SET_PERFORMANCE_OPTION_FILTER:
      return { ...state, filter: { ...state.filter, option: action.payload } };
    case actions.ActionTypes.SET_PERFORMANCE_FUND_FILTER:
      return { ...state, filter: { ...state.filter, fund: action.payload } };
    case actions.ActionTypes.SET_PERFORMANCE_YEAR_FILTER:
      return { ...state, filter: { ...state.filter, year: action.payload } };
    case actions.ActionTypes.SET_PERFORMANCE_MONTH_FILTER:
      return { ...state, filter: { ...state.filter, month: action.payload } };

    case actions.ActionTypes.RESET_PERFORMANCE_FILTER:
      return { ...state, filter: { ...initialState.filter, month: undefined, year: undefined }};
    case actions.ActionTypes.RESET_PERFORMANCE_DATA:
      return initialState;
    default:
      return state;
  }
}
